import { observable } from 'mobx';

export class TrainingsPageParams {
  @observable year: number = 0;
  @observable month: number = 0;
  @observable groupId: number = 0;
}
